import { render, staticRenderFns } from "./EducationalCourseLevelQuestions.vue?vue&type=template&id=1f650c50&"
import script from "./EducationalCourseLevelQuestions.vue?vue&type=script&lang=js&"
export * from "./EducationalCourseLevelQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports